module.exports = __webpack_public_path__ + "static/media/logo-short.e0a26f7d.svg";